define(['angular'], function(angular) {


    function EmailProvider() {
        var bdcUrl;

        this.setBDCUrl = function setBDCUrl(url) {
            bdcUrl = url;
        };

        this.$get = [
            '$http',
            function($http) {
                var self = {};

                /**
                 * @param  {Object} options
                 *
                 * @return {}
                 */
                self.send = function send(options) {
                    return $http.post(bdcUrl + 'email/send', options).then(function(res) {
                        return res.data;
                    });
                };

                return self;
            }
        ];
    }

    angular.module('app.bdc.common.emailProvider', []).provider('email', EmailProvider);
});
